// import PropTypes from 'prop-types';
import React from 'react';

import { basePageWrap } from '../BasePage';
import styles from './ArtistPage.module.scss';
import PropTypes from 'prop-types';

//Components
import Image from '../../components/Image';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import RawHtml from '../../components/RawHtml/RawHtml';
import Flag from 'react-world-flags';
import Breadcrumbs from '../../components/Breadcrumbs';

const ArtistPage = ({
    settings,
    associatedActs,
    title,
    preamble,
    image,
    richText,
    gear,
    country,
    breadcrumbs,
}) => {
    return (
        <div className={styles['ArtistPage']}>
            <Header {...settings.header} />
            <main>
                <div className={styles['ArtistPage__Breadcrumbs']}>
                    <Breadcrumbs {...breadcrumbs} />
                </div>
                <div className={styles['ArtistPage__Container']}>
                    <div className={styles['ArtistPage__Hero']}>
                        <div className={styles['ArtistPage__InfoWrapper']}>
                            <h1 className={styles['ArtistPage__Title']}>
                                {title}
                                {country && (
                                    <span
                                        className={styles['ArtistPage__Flag']}>
                                        <Flag code={country} />
                                    </span>
                                )}
                            </h1>
                            <p className={styles['ArtistPage__Preamble']}>
                                {preamble}
                            </p>
                        </div>

                        <div className={styles['ArtistPage__ImageWrapper']}>
                            {image && (
                                <Image
                                    {...image}
                                    objectFit="cover"
                                    priority={true}
                                />
                            )}
                        </div>
                    </div>
                    <div className={styles['ArtistPage__Content']}>
                        <div className={styles['ArtistPage__TextWrapper']}>
                            {richText && (
                                <div className={styles['ArtistPage__RichText']}>
                                    <RawHtml html={richText} />
                                </div>
                            )}
                        </div>

                        <div className={styles['ArtistPage__SideWrap']}>
                            {associatedActs && (
                                <>
                                    <h2
                                        className={
                                            styles['ArtistPage__SubTitle']
                                        }>
                                        Associated acts
                                    </h2>
                                    <p
                                        className={
                                            styles['ArtistPage__AssociatedActs']
                                        }>
                                        {associatedActs}
                                    </p>
                                </>
                            )}
                            {gear && gear.length > 0 && (
                                <>
                                    <h2
                                        className={
                                            styles['ArtistPage__SubTitle']
                                        }>
                                        Gear
                                    </h2>
                                    <div
                                        className={
                                            styles['ArtistPage__GearList']
                                        }>
                                        {gear.map((item) => (
                                            <a
                                                href={item?.link.href}
                                                className={
                                                    styles['ArtistPage__Gear']
                                                }>
                                                {item.productLogoImage && (
                                                    <div
                                                        className={
                                                            styles[
                                                                'ArtistPage__ProductLogoImageWrapper'
                                                            ]
                                                        }>
                                                        <Image
                                                            {...item.productLogoImage}
                                                            layout="fill"
                                                            objectFit="contain"
                                                            priority={true}
                                                            focal={{
                                                                x: '0%',
                                                                y: '50.00%',
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                {item.productImage && (
                                                    <div
                                                        className={
                                                            styles[
                                                                'ArtistPage__ProductImageWrapper'
                                                            ]
                                                        }>
                                                        <Image
                                                            {...item.productImage}
                                                            layout="fill"
                                                            objectFit="contain"
                                                            priority={true}
                                                            focal={{
                                                                x: '0%',
                                                                y: '50.00%',
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </a>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

ArtistPage.propTypes = {
    settings: PropTypes.object,
    artistInfo: PropTypes.object,
};

ArtistPage.defaultProps = {
    settings: {
        footer: {},
    },
};

export default basePageWrap(ArtistPage);
